export const EVENT_PING = 'ping'
export const EVENT_PONG = 'pong'
export const EVENT_REQUEST = 'request'
export const EVENT_AUTH = 'auth'
